/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m30 22.9136c.553 0 1 .448 1 1v2.435c0 2.565-2.087 4.651-4.651 4.651h-20.698c-2.564 0-4.651-2.086-4.651-4.651v-2.435c0-.552.447-1 1-1s1 .448 1 1v2.435c0 1.462 1.189 2.651 2.651 2.651h20.698c1.462 0 2.651-1.189 2.651-2.651v-2.435c0-.552.447-1 1-1zm-13.292-21.6191 8.908 8.908c.391.391.391 1.024 0 1.414-.39.391-1.023.391-1.414 0l-7.202-7.202v19.36c0 .553-.447 1-1 1s-1-.447-1-1v-19.36l-7.202 7.202c-.391.391-1.024.391-1.414 0-.391-.39-.391-1.023 0-1.414l8.908-8.908c.093-.093.203-.166.326-.217.122-.051.252-.077.382-.077s.26.026.382.077c.123.051.233.124.326.217z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;